import React from 'react';
import PropTypes from 'prop-types';
import Lightbox from '../lightbox/lightbox';
import { SelectFSLightBoxHeader } from './select_fs_light_box_header';
import { SelectFSLightBoxContent } from './select_fs_light_box_content';

function SelectFSLightBox(props) {
    return (
        <Lightbox
            opened={props.visible}
            onClose={props.onClose}
            additionalClassNames={['select-fs-light-box__lightbox']}
            headerIcon="lightbox__header-icon icon-fitting bg-primary"

        >
            <div className="select-fs-light-box">
                <SelectFSLightBoxHeader data={props.data} error={props.error} />
                <SelectFSLightBoxContent
                    error={props.error}
                    onContinueShopping={props.onContinueShopping}
                    onSelectMyTyreClick={props.onSelectMyTyreClick}
                />
            </div>
        </Lightbox>
    );
}

SelectFSLightBox.propTypes = {
    visible: PropTypes.bool.isRequired,
    error: PropTypes.object,
    onContinueShopping: PropTypes.func.isRequired,
    onSelectMyTyreClick: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
};

export { SelectFSLightBox };
